import React from "react";
import locale from "@bonliva-crm/locale";
import { Typography } from "@material-ui/core";
import { Face } from "@material-ui/icons";

export function Empty() {
  return (
    <div style={styles.root}>
      <Face style={styles.icon} />
      <Typography variant="subtitle1">{locale.SelectBA}</Typography>
    </div>
  );
}

const styles = {
  root: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: 200
  },

  icon: {
    marginRight: 8
  }
};
